import React from 'react';
import { Title } from '../components/ui/Title';
import contact from '../assets/contact.png';

function Contact() {
  return (
    <div className="container mx-auto px-6 py-8 md:py-24">
      <Title>Contact</Title>
      
      <div className="max-w-3xl mx-auto panel">        
        <div className="space-y-8 text-light/80 text-center">
          <img className="inline-block" width={160} src={contact} alt="Contact"  loading="lazy" />

          <p className="font-tilt-warp text-3xl">Wir stehen Dir gerne zur Verfügung!</p>

          <p>Wir antworten gerne auf Deine Fragen und Anregungen, sowie auf kreative Ideen, die Du mit uns teilen möchtest - per Mail.</p>

           <p>
             <a className="w-fit btn-secondary h-12 flex items-center justify-center" href="mailto:info@jamnation.ch">Kontaktiere uns!</a>
           </p>
        </div>
      </div>
    </div>
  );
}

export default Contact;